import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Promedio } from '../models/promedio';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Promedios';

@Injectable({
  providedIn: 'root'
})
export class PromediosService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  save(promedio: Promedio)
  {
    return this._http.post({ url: baseUrl + '/Save', body: promedio });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

  getListAgrupada(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/ListAgrupada' })
  }
}